import {useContext} from 'react'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import MoleculeModal from '@s-ui/react-molecule-modal'
import MoleculeNotification, {
  moleculeNotificationAlignItems,
  moleculeNotificationBorderSizes,
  moleculeNotificationTypes,
  moleculeNotificationVariations
} from '@s-ui/react-molecule-notification'
import {useLocation} from '@s-ui/react-router'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import IconCircleCheck from '@adv-mt/mt-svg-icons/lib/CircleCheck.js'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'

import {useMessagingContext} from '../../useMessagingContext/index.js'

export const ConfirmPriceTransactionModal = () => {
  const {state: routerState} = useLocation()
  const {i18n} = useContext(Context)
  const {setInteractionComponent} = useMessagingContext()

  const {adPrice, agreedPrice} = routerState || {}

  return (
    <MoleculeModal
      isOpen
      closeOnOutsideClick
      closeOnEscKeyDown
      iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
      onClose={() => setInteractionComponent({component: null, show: false})}
    >
      <div className="mt-TransactionConfirmPriceModal-modalContainer">
        <MoleculeNotification
          alignItems={moleculeNotificationAlignItems.CENTER}
          autoClose={null}
          icon={<IconCircleCheck size="medium" />}
          position="relative"
          roundedCorners={moleculeNotificationBorderSizes.medium}
          show
          showCloseButton={false}
          showLeftIconMobile
          type={moleculeNotificationTypes.success}
          variation={moleculeNotificationVariations.positive}
        >
          {i18n.t(`COMMON.CONFIRMED_PRICE`)}
        </MoleculeNotification>
        <ModalBasicContent
          stepsContent={[
            {
              buttons: {
                confirmButton: {
                  customCallBack: () => {
                    setInteractionComponent({component: null, show: false})
                  },
                  text: i18n.t('COMMON.UNDERSTOOD')
                }
              },
              children: (
                <div className="mt-TransactionConfirmPriceModal-modalChildren">
                  <div className="mt-TransactionConfirmPriceModal-description">
                    {i18n.t('VEHICLE_TRANSACTION.CONFIRM_PRICE.MODAL_TEXT')}
                  </div>
                  <div className="mt-TransactionConfirmPriceModal-priceWrapper">
                    <div className="mt-TransactionConfirmPriceModal-adPrice">
                      <span className="mt-TransactionConfirmPriceModal-adPriceLabel">
                        {i18n.t('VEHICLE_TRANSACTION.CONFIRM_PRICE.AD_PRICE')}
                      </span>
                      <span className="mt-TransactionConfirmPriceModal-adPriceValue">
                        {adPrice ? i18n.c(adPrice) : null}
                      </span>
                    </div>
                    <div className="mt-TransactionConfirmPriceModal-agreedPrice">
                      <span className="mt-TransactionConfirmPriceModal-agreedPriceLabel">
                        {i18n.t('VEHICLE_TRANSACTION.CONFIRM_PRICE.AGREED_PRICE')}
                      </span>
                      <span className="mt-TransactionConfirmPriceModal-agreedPriceValue">
                        {agreedPrice ? i18n.c(agreedPrice) : null}
                      </span>
                    </div>
                  </div>
                </div>
              ),
              title: i18n.t('VEHICLE_TRANSACTION.CONFIRM_PRICE.MODAL_TITLE'),
              titleMarginBottom: 'l'
            }
          ]}
        />
      </div>
    </MoleculeModal>
  )
}
